<template>
  <div class="user-manage">
    <div class="create-project">
      <span class="title">创建标注员</span>
      <span class="new" @click="newTagger">
        <a-icon type="plus" />
        新建标注员
      </span>
    </div>
    <div class="tast-list">
      <div style="padding:0 24px">
        <div class="title">用户列表</div>
      </div>
      <a-divider style="margin:10px 0 0px 0;color:#F7F7F7"/>
      <div style="clear:both"></div>
      <div class="select-condition">
        <div class="select-list">
          <span>标注员：</span>
          <a-input-search v-model="conditionObj.userName" placeholder="请输入" style="width: 200px" />
        </div>
        <div class="select-list">
          <span>用户状态：</span>
          <a-select style="width:190px"
            @change="changeUserState"
            :defaultValue="defaultUserState"
            :key="defaultUserState"
            v-model="conditionObj.type2"
          >
            <a-select-option value=''>全部</a-select-option>
            <a-select-option value='NORMAL'>正常</a-select-option>
            <a-select-option value='DISABLED'>停用</a-select-option>
          </a-select>
        </div>
        <div class="btn-list">
          <span @click="resetCondition">重置</span>
          <span @click="queryData">查询</span>
        </div>
      </div>
        <div style="padding:24px 24px 50px 24px;">
        <a-table :data-source="data" :pagination='false' :loading="ifShowLoading">
          <a-table-column key="name" title="账号" data-index="name" />
          <!-- <a-table-column key="rightRate" title="总正确率" data-index="rightRate" /> -->
          <a-table-column key="rightRate" title="总正确率" data-index="rightRate">
            <template slot-scope="text, record">
              <div>
                <span>{{ record.rightRate?(record.rightRate!=0?record.rightRate+'%':record.rightRate):'' }}</span>
              </div>
            </template>
          </a-table-column>
          <!-- <a-table-column key="doubtRate" title="总存疑率" data-index="doubtRate" />
          <a-table-column key="errorRate" title="总错误率" data-index="errorRate" /> -->
          <a-table-column key="doubtRate" title="总存疑率" data-index="doubtRate">
            <template slot-scope="text, record">
              <div>
                <span>{{ record.doubtRate?(record.doubtRate!=0?record.doubtRate+'%':record.doubtRate):record.doubtRate }}</span>
              </div>
            </template>
          </a-table-column>
          <a-table-column key="errorRate" title="总错误率" data-index="errorRate">
            <template slot-scope="text, record">
              <div>
                <span>{{ record.errorRate?(record.errorRate!=0?record.errorRate+'%':record.errorRate):record.errorRate }}</span>
              </div>
            </template>
          </a-table-column>
          <a-table-column key="status" title="用户id" data-index="status">
            <template slot-scope="text, record">
              <div>
                <span v-if="record.status=='NORMAL'">正常</span>
                <span v-if="record.status=='DISABLED'">停用</span>
              </div>
            </template>
          </a-table-column>
          <!-- <a-table-column key="statusStr" title="操作" data-index="statusStr" /> -->
          <a-table-column key="id" title="操作" data-index="id">
            <template slot-scope="text, record">
              <div>
                <span @click="editUser(record.id)" style="cursor:pointer;color:rgba(24, 144, 255, 1)">编辑</span>
              </div>
            </template>
          </a-table-column>
        </a-table>
        <div style="font-size:14px;margin-top:16px;float:left">
          <span style="color:rgba(80, 80, 80, 1)">总计：</span>
          <span style="color:rgba(24, 144, 255, 1)">{{total}}个</span>
        </div>
        <a-pagination
          style="float:right;margin-top:16px"
          v-model="conditionObj.current"
          :page-size-options="pageSizeOptions"
          :total="total"
          show-size-changer
          :page-size="conditionObj.size"
          @showSizeChange="onShowSizeChange"
          @change="onChangeSample"
        >
          <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }}条/页</span>
          </template>
        </a-pagination>
        <div style="clear:both"></div>
      </div>

    </div>
    <a-modal v-model="visibleUser" title="创建新用户" :footer='null' :maskClosable='false' width='580px'>
      <div>
        <div style="margin-bottom:16px;">
          <span style="display:inline-block;width:75px;color:rgba(153, 153, 153, 1);font-size:14px;">账号：</span>
          <a-input v-model="newUserInfo.account" style="width:440px" placeholder="请输入" />
        </div>
        <div style="margin-bottom:16px;">
          <span style="display:inline-block;width:75px;color:rgba(153, 153, 153, 1);font-size:14px;">密码：</span>
          <a-input v-model="newUserInfo.password" style="width:440px" placeholder="请输入" type="password" />
        </div>
        <div style="margin-bottom:16px;">
          <span style="display:inline-block;width:75px;color:rgba(153, 153, 153, 1);font-size:14px;">确认密码：</span>
          <a-input v-model="newUserInfo.repeatPassword" style="width:440px" placeholder="请输入" type="password" />
        </div>
        <div style="margin-bottom:16px;">
          <span style="display:inline-block;width:75px;float:left;color:rgba(153, 153, 153, 1);font-size:14px;">备注：</span>
          <a-textarea v-model="newUserInfo.remark" style="width:440px" placeholder="请输入" :rows="4" />
        </div>
        <div style="clear:both"></div>
        <div style="text-align:center;margin-top:8px">
          <span @click="createUser" style="width:88px;height:32px;text-align:center;line-height:32px;border-radius:4px;color:#fff;background:rgba(24, 144, 255, 1);display:inline-block;cursor:pointer">创建</span>
        </div>
      </div>
    </a-modal>
    <a-modal v-model="visibleInfo" title="用户信息编辑" :footer='null' :maskClosable='false' width='580px'>
      <div>
        <div style="margin-bottom:24px;">
          <span style="display:inline-block;width:75px;color:rgba(153, 153, 153, 1);font-size:14px;">账号：</span>
          <span>{{userInfoDetail.name}}</span>
        </div>
        <div style="margin-bottom:24px;">
          <span style="display:inline-block;width:75px;color:rgba(153, 153, 153, 1);font-size:14px;">密码：</span>
          <span v-if="!passwordShow" style="display:inline-block;width:400px;color:rgba(80, 80, 80, 1);font-size:14px;">******</span>
          <a-input v-model="changePassword1" style="width:400px" v-if="passwordShow" placeholder="" type="password" />
          <span @click="changePassword" v-if="!passwordShow" style="font-size:14px;color:rgba(24, 144, 255, 1);margin-left:24px;cursor:pointer">修改</span>
          <span @click="savePassword(userInfoDetail.id)" v-if="passwordShow" style="font-size:14px;color:rgba(24, 144, 255, 1);margin-left:24px;cursor:pointer">保存</span>
        </div>
        <div style="margin-bottom:24px;" v-if="passwordShow">
          <span style="display:inline-block;width:75px;color:rgba(153, 153, 153, 1);font-size:14px;">确认密码：</span>
          <a-input v-model="changePassword2" style="width:400px" placeholder="" type="password" />
        </div>
        <div style="margin-bottom:24px;">
          <span style="display:inline-block;width:75px;color:rgba(153, 153, 153, 1);font-size:14px;float:left">备注：</span>
          <a-textarea style="width:400px;float:left" :disabled="!changeInfoExtra" placeholder="请输入" v-model="userInfoDetail.remark" :rows="4" />
          <span v-if="!changeInfoExtra" @click="changeExtraInfo" style="font-size:14px;color:rgba(24, 144, 255, 1);margin-left:24px;float:left;cursor:pointer">修改</span>
          <span v-if="changeInfoExtra" @click="saveExtraInfo(userInfoDetail.id)" style="font-size:14px;color:rgba(24, 144, 255, 1);margin-left:24px;float:left;cursor:pointer">保存</span>
        </div>
        <div style="clear:both"></div>
        <div style="margin-top:24px;">
          <span style="display:inline-block;width:75px;color:rgba(153, 153, 153, 1);font-size:14px;">状态更改：</span>
          <span v-if="!stateShow" style="display:inline-block;width:400px;color:rgba(80, 80, 80, 1);font-size:14px;">{{userInfoDetail.status=='NORMAL'?'正常':'停用'}}</span>
          <span v-if="stateShow" style="display:inline-block;width:400px">
            <a-select :default-value="userInfoDetail.status" 
            style="width: 120px" 
            @change="changeStateValue" 
            :defaultValue="defaultUserStateValue"
            :key="defaultUserStateValue"
            v-model="userInfoDetail.status">
              <a-select-option value="NORMAL">
                正常
              </a-select-option>
              <a-select-option value="DISABLED">
                停用
              </a-select-option>
            </a-select>
          </span>
          <span v-if="!stateShow" @click="changeState" style="font-size:14px;color:rgba(24, 144, 255, 1);margin-left:24px;cursor:pointer">修改</span>
          <span v-if="stateShow" @click="saveState(userInfoDetail.id)" style="font-size:14px;color:rgba(24, 144, 255, 1);margin-left:24px;cursor:pointer">保存</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'UserManage',
  props: {
    msg: String
  },
   data() {
    return {
      conditionObj: {
        userName: '',
        current: 1,
        size: 10,
        type2: '',
      },
      defaultUserState: '全部',
      visibleUser: false,
      visibleInfo: false,
      passwordShow: false,
      userInfoExtra: '这里是备注信息，比如该用户的收款账户。这里是备注信息，比如该用户的收款账户。这里是备注信息，比如该用户的收款账户。这里是备注信息，比如该用户的收款账户。',
      changeInfoExtra: false,
      stateShow: false,
      data: [],
      ifShowLoading: false,
      pageSizeOptions: ['10', '20', '50', '100'],
      total: 0,
      newUserInfo: {
        account: '',
        password: '',
        repeatPassword: '',
        remark: ''
      },
      changePassword1: '',
      changePassword2: '',
      userStateValue: '',
      defaultUserStateValue: '全部',
      userInfoDetail: '',
    }
  },
  methods: {
    changeUserState(value) {
      this.conditionObj.type2 = value
    },
    resetCondition() {
      this.conditionObj = {
        userName: '',
        current: 1,
        size: 10,
        type2: '',
        orderField: '',
        orderDirection: ''
      }
      this.queryData()
    },
    queryData() {
      this.axios({
        url: '/api/manager/user/list', 
        method: 'get',
        params: {
          current: this.conditionObj.current,
          size: this.conditionObj.size,
          status: this.conditionObj.type2,
          name: this.conditionObj.userName,
        }
      })
      .then(response=> {
        if(response.data.code == 0){
          this.data = response.data.data.records
          this.total = response.data.data.total
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    newTagger() {
      this.visibleUser = true
    },
    createUser() {
      this.visibleUser = false
      if(this.newUserInfo.password == this.newUserInfo.repeatPassword){
        this.axios.post('/api/manager/user', {
          name: this.newUserInfo.account,
          password: this.newUserInfo.password,
          remark: this.newUserInfo.remark,
        })
        .then(response=> {
          if(response.data.code == 0){
            this.$parent.success('创建成功');
            this.queryData()
          }else{
            this.$parent.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }else{
        this.$parent.error('两次密码不一致');
      }
    },
    editUser(id) {
      this.visibleInfo = true
      this.axios({
        url: '/api/manager/user', 
        method: 'get',
        params: {
          id: id,
        }
      })
      .then(response=> {
        if(response.data.code == 0){
          this.userInfoDetail = response.data.data
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    changePassword() {
      this.passwordShow = true
    },
    savePassword(id) {
      this.passwordShow = false
      this.visibleInfo = false
      if(this.changePassword1 == this.changePassword2){
        this.axios.post('/api/manager/user/password', {
          id: id,
          password: this.changePassword1,
        })
        .then(response=> {
          if(response.data.code == 0){
            this.$parent.success('修改成功');
          }else{
            this.$parent.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }else{
        this.$parent.error('两次密码不一致');
      }
    },
    changeExtraInfo() {
      this.changeInfoExtra = true
    },
    saveExtraInfo(id) {
      this.changeInfoExtra = false
      this.visibleInfo = false
      this.axios.post('/api/manager/user/remark', {
        id: id,
        remark: this.userInfoDetail.remark,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$parent.success('修改成功');
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    changeState() {
      this.stateShow = true
    },
    changeStateValue(value) {
      this.userStateValue = value
    },
    saveState(id) {
      this.stateShow = false
      this.visibleInfo = false
      this.axios.post('/api/manager/user/status', {
        id: id,
        status: this.userStateValue,
      })
      .then(response=> {
        if(response.data.code == 0){
          
          this.$parent.success('修改成功');
          this.queryData()
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    onShowSizeChange(current, pageSize) {
      this.conditionObj.current = current
      this.conditionObj.size = pageSize;
      this.queryData()
    },
    onChangeSample(value) {
      this.conditionObj.current = value
      this.queryData()
    },
  },
  mounted: function() {
    this.queryData()
  }
}
</script>

<style scoped lang="less">
  .user-manage{
     padding: 24px;
    background: rgba(245, 246, 247, 1);
    .create-project{
      height: 64px;
      color: rgba(80, 80, 80, 1);
      background-color: rgba(255, 255, 255, 1);
      border-radius: 4px;
      font-size: 14px;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
      padding: 20px 24px;
      .title{
        color: rgba(51, 51, 51, 1);
        font-size: 16px;
      }
      .new{
        width: 108px;
        height: 32px;
        background: rgba(34, 215, 187, 1);
        color: #fff;
        text-align: center;
        line-height: 32px;
        display: inline-block;
        border-radius: 4px;
        float: right;
        cursor: pointer;
      }
    }
    .tast-list{
      margin-top: 16px;
      padding: 12px 0;
      background:#fff;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      .title{
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        display: inline-block;
      }
      .select-condition{
        margin-top: 20px;
        padding: 0 24px;
        .select-list{
          display: inline-block;
          margin-right: 122px;
          span{
            margin-right: 20px;
          }
        }
        .btn-list{
          float: right;
          span{
            display: inline-block;
            width: 80px;
            height: 32px;
            text-align: center;
            line-height: 32px;
            font-size: 14px;
            cursor: pointer;
            border-radius: 4px;
            margin-left: 12px;
          }
          span:nth-child(1){
            color: rgba(24, 144, 255, 1);
            border: 1px solid rgba(24, 144, 255, 1);
          }
          span:nth-child(2){
            background: rgba(24, 144, 255, 1);
            color: #fff;
          }
        }
      }
    }
  }
</style>
